import React from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import ZInput from '../../z-input';
import ZTextArea from '../../z-text-area';
import ZToggle from '../../z-toggle';
import ZButton from '../../z-button';
import ZSpinner from '../../z-spinner';
import { decodeHTMLEntities } from '../../../utils/window';
import style from './team-member-editor.module.scss';
import TeamImage from './content-image';

const TeamMemberEditorView = ({
  closeModal,
  displayed,
  error,
  id,
  isSaving,
  onChangeDisplayed,
  onClickSave,
  saveDisabled,
  setDescription,
  setTitle,
  setName,
  description,
  title,
  name,
  image,
  onRemovePhoto,
  onCreatePhoto,
  onChangePhoto,
  onClickDelete,
  deleteError,
  onImageChangesStatusChange,
  hasUnsavedImageChanges,
}) => (
  <div className={style['editor']}>
    <div className={style['editor__header']}>
      <h2>{id === 'new' ? 'Add New Team Member' : 'Edit Team Member'}</h2>
      <div className={style['editor__toggle']}>
        <ZToggle
          checked={displayed}
          label="Displayed"
          onChange={onChangeDisplayed}
        />
      </div>
    </div>

    <div className={`${style['editor__form-section']} ${style['editor__form-section--image']}`}>
      <div className="section-title">Team Member Photo</div>
      <TeamImage
        entityId={id}
        photo={image}
        photoId={image.id}
        onRemovePhoto={onRemovePhoto}
        onCreatePhoto={onCreatePhoto}
        onChangePhoto={onChangePhoto}
        showInfo={false}
        onImageChangesStatusChange={onImageChangesStatusChange}
      />
    </div>

    <div className={`${style['editor__form-section']} ${style['editor__form-section--fields']}`}>
      <div className={style['editor__required-note']}>
        <span style={{ color: '#ee2a23', fontWeight: '600' }}>*</span> indicates required fields
      </div>
      
      <div className={style['editor__field-row']}>
        <ZInput
          inputId="name"
          label="Full Name *"
          onChange={setName}
          placeholder="Enter full name (required)"
          style={{ 
            marginBottom: '0',
            width: '100%',
          }}
          text={name}
        />
        <ZInput
          inputId="title"
          label="Job Title *"
          onChange={setTitle}
          placeholder="Enter job title (required)"
          style={{ 
            marginBottom: '0',
            width: '100%',
          }}
          text={decodeHTMLEntities(title)}
        />
      </div>

      <div className="field-full">
        <ZTextArea
          allowedFormats={[]}
          label="Description *"
          onUpdate={setDescription}
          placeholder="Enter team member description (required)"
          style={{ marginBottom: '0' }}
          textAreaStyle={{ 
            maxHeight: '200px', 
            overflow: 'auto',
            minHeight: '120px',
          }}
          value={description}
        />
      </div>
    </div>

    {error && (
      <div className={style['error']}>
        There was an error saving this team member. Please try again.
      </div>
    )}
    
    {deleteError && (
      <div className={style['error']}>
        There was an error deleting this team member. Please try again.
      </div>
    )}

    {hasUnsavedImageChanges && (
      <div className={style['warning']}>
        <strong>Unsaved Image Changes:</strong> You have made changes to the image that haven't been saved yet. 
        Please click "Add Image" or "Update Image" in the photo section above before saving the team member.
      </div>
    )}

    <div className={style['editor__buttons']}>
      {isSaving ? (
        <div className={style['spinner-container']}>
          <ZSpinner />
        </div>
      ) : (
        <>
          <ZButton
            btnClass={`${style['editor__button']} ${style['editor__button--primary']}`}
            disabled={saveDisabled}
            onClick={onClickSave}
            text={id === 'new' ? 'Create Team Member' : 'Save Changes'}
          />
          <ZButton
            btnClass={`${style['editor__button']} ${style['editor__button--secondary']}`}
            onClick={closeModal}
            text="Cancel"
          />
          {id !== 'new' && (
            <ZButton
              btnClass={`${style['editor__button']} ${style['editor__button--danger']}`}
              disabled={saveDisabled}
              onClick={onClickDelete}
              text="Delete"
            />
          )}
        </>
      )}
    </div>
  </div>
);

export default TeamMemberEditorView;
